"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Features = require("./Features");
Object.keys(_Features).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Features[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Features[key];
    }
  });
});